
import { Resume } from './resume';

export class ResumePayload {
    public accessToken: string = '';
    public resumefile: any;
    public resumelink: string = '';
    public jobpostingid: number = 0;
    public userId: number = 0;
    public resume: Resume = new Resume();
}
